module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.2937/img/blobsLeft.png"